import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
    AllCampaignsLoadedError,
    AllCampaignsLoadedSuccess,
    AllChannelsLoadedError,
    AllChannelsLoadedSuccess,
    UserAgentChannelLoadingError,
    UserAgentChannelLoadingFinished,
    UserAgentLoadingError,
    UserAgentLoadingFinished,
} from '@/store/activity/devices/actions';
import { getAllCampaigns, getAllChannels, getUserAgentCampaignStats, getUserAgentStats } from '@/services/ElasticApi';
import { DevicesChannelFetchStartAction, DevicesFetchStartAction } from '@/store/activity/devices/types';
import { Logger } from '@/services/errors/appLogger';

function* fetchCampaignsList(): any {
    const params = {};

    try {
        const campaigns = yield call(getAllCampaigns, params);

        yield put(AllCampaignsLoadedSuccess(campaigns));
    } catch (e) {
        Logger.error(e);
        yield put(AllCampaignsLoadedError());
    }
}

function* fetchChannelsList(): any {
    const params = {};
    try {
        const channels = yield call(getAllChannels, params);
        yield put(AllChannelsLoadedSuccess(channels.data));
    } catch (e) {
        Logger.error(e);
        yield put(AllChannelsLoadedError());
    }
}

function* fetchUserAgentActivity(action: DevicesFetchStartAction): any {
    const { payload } = action;
    const params = {
        from: payload.from,
        to: payload.to,
    };

    try {
        const userAgentActivity = yield call(getUserAgentStats, params);
        yield put(UserAgentLoadingFinished(userAgentActivity));
    } catch (e) {
        Logger.error(e);
        yield put(UserAgentLoadingError());
    }
}

function* fetchUserAgentChannelActivity(action: DevicesChannelFetchStartAction): any {
    const { payload } = action;
    const params = {
        campaignName: payload.name,
        from: payload.from,
        to: payload.to,
    };

    try {
        const userAgentChannelActivity = yield call(getUserAgentCampaignStats, params);
        yield put(UserAgentChannelLoadingFinished(userAgentChannelActivity));
    } catch (e) {
        Logger.error(e);
        yield put(UserAgentChannelLoadingError());
    }
}

function* watchFetchCampaignsList(): any {
    yield takeEvery('@@allcampaigns/FETCH_START', fetchCampaignsList);
}

function* watchFetchChannelsList(): any {
    yield takeEvery('@@allchannels/FETCH_START', fetchChannelsList);
}

function* watchFetchUserAgentActivity(): any {
    yield takeEvery('@@devices/FETCH_START', fetchUserAgentActivity);
}

function* watchFetchUserAgentChannelActivity(): any {
    yield takeEvery('@@deviceschannel/FETCH_START', fetchUserAgentChannelActivity);
}

const deviceDetailsSagas = [
    fork(watchFetchCampaignsList),
    fork(watchFetchChannelsList),
    fork(watchFetchUserAgentActivity),
    fork(watchFetchUserAgentChannelActivity),
];
export default deviceDetailsSagas;
